module.exports = __webpack_public_path__ + "img/male.440a4632.svg";